import { Controller } from "@hotwired/stimulus"

// Lignes d'un tableau éditable (Modèle de bulletin : cotes, mentions).
// « Ajouter » clone le <template> placé dans le contrôleur ; la corbeille
// retire sa ligne. Les noms de champs sont en `xxx[]`, l'ordre suit les lignes.
export default class extends Controller {
  static targets = ["body", "template"]

  add() {
    this.bodyTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
    const inputs = this.bodyTarget.lastElementChild?.querySelectorAll("input, select")
    inputs?.[0]?.focus()
  }

  remove(event) {
    event.target.closest("tr")?.remove()
  }
}
